// import React, { useState } from 'react';
// import {
//   Box,
//   TextField,
//   Button,
//   Grid,
//   FormControlLabel,
//   Switch,
//   Chip,
//   IconButton,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   OutlinedInput,
//   Checkbox,
//   ListItemText,
//   Paper,
//   Divider,
//   FormHelperText,
// } from '@mui/material';
// import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
// import { useDispatch } from 'react-redux';
// import { createPlan, updatePlan } from '../../redux/slices/planSlice';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';

// const platforms = ['WEB', 'ANDROID', 'IOS'];
// const billingTypes = ['one-time', 'monthly', 'yearly'];

// const PlanForm = ({ plan, onClose }) => {
//   const dispatch = useDispatch();
//   const [formData, setFormData] = useState({
//     name: plan?.name || '',
//     platforms: plan?.platforms || [],
//     title: plan?.title || '',
//     billingOptions: {
//       monthly: {
//         price: plan?.billingOptions?.monthly?.price || '',
//         discount: plan?.billingOptions?.monthly?.discount || 0,
//       },
//       yearly: {
//         price: plan?.billingOptions?.yearly?.price || '',
//         discount: plan?.billingOptions?.yearly?.discount || 0,
//       },
//     },
//     planValidity: plan?.planValidity || 30,
//     dealerLimit: plan?.dealerLimit || '',
//     extraDealerPrice: plan?.extraDealerPrice || '',
//     setupFee: plan?.setupFee || 0,
//     features: plan?.features || [''],
//     addOns: plan?.addOns || [{ title: '', price: '', description: '', billingType: 'monthly' }],
//     isPopular: plan?.isPopular || false,
//     isActive: plan?.isActive ?? true,
//     expiryDate: plan?.expiryDate ? dayjs(plan.expiryDate) : null,
//     hasTrial: plan?.hasTrial || false,
//     customPlan: plan?.customPlan || false,
//     trialDays: plan?.trialDays || 0,
//   });

//   const [errors, setErrors] = useState({});

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.name) newErrors.name = 'Name is required';
//     if (formData.platforms.length === 0) newErrors.platforms = 'At least one platform is required';
    
//     if (!formData.billingOptions.monthly.price || formData.billingOptions.monthly.price < 0) {
//       newErrors.monthlyPrice = 'Valid monthly price is required';
//     }
//     if (!formData.billingOptions.yearly.price || formData.billingOptions.yearly.price < 0) {
//       newErrors.yearlyPrice = 'Valid yearly price is required';
//     }
    
//     if (!formData.dealerLimit || formData.dealerLimit < 0) {
//       newErrors.dealerLimit = 'Valid dealer limit is required';
//     }
//     if (!formData.extraDealerPrice || formData.extraDealerPrice < 0) {
//       newErrors.extraDealerPrice = 'Valid extra dealer price is required';
//     }
    
//     return newErrors;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     if (name.includes('.')) {
//       const [parent, child, grandChild] = name.split('.');
//       if (grandChild) {
//         setFormData(prev => ({
//           ...prev,
//           [parent]: {
//             ...prev[parent],
//             [child]: {
//               ...prev[parent][child],
//               [grandChild]: type === 'number' ? parseFloat(value) || 0 : value,
//             }
//           }
//         }));
//       } else {
//         setFormData(prev => ({
//           ...prev,
//           [parent]: {
//             ...prev[parent],
//             [child]: type === 'number' ? parseFloat(value) || 0 : value,
//           }
//         }));
//       }
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: type === 'checkbox' ? checked : (type === 'number' ? parseFloat(value) || 0 : value),
//       }));
//     }
//   };

//   const handleFeatureChange = (index, value) => {
//     const updatedFeatures = [...formData.features];
//     updatedFeatures[index] = value;
//     setFormData(prev => ({ ...prev, features: updatedFeatures }));
//   };

//   const addFeature = () => {
//     setFormData(prev => ({
//       ...prev,
//       features: [...prev.features, ''],
//     }));
//   };

//   const removeFeature = (index) => {
//     if (formData.features.length > 1) {
//       setFormData(prev => ({
//         ...prev,
//         features: prev.features.filter((_, i) => i !== index),
//       }));
//     }
//   };

//   const handleAddOnChange = (index, field, value) => {
//     const updatedAddOns = [...formData.addOns];
//     updatedAddOns[index] = { ...updatedAddOns[index], [field]: value };
//     setFormData(prev => ({ ...prev, addOns: updatedAddOns }));
//   };

//   const addAddOn = () => {
//     setFormData(prev => ({
//       ...prev,
//       addOns: [...prev.addOns, { title: '', price: '', description: '', billingType: 'monthly' }],
//     }));
//   };

//   const removeAddOn = (index) => {
//     if (formData.addOns.length > 1) {
//       setFormData(prev => ({
//         ...prev,
//         addOns: prev.addOns.filter((_, i) => i !== index),
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     const newErrors = validateForm();
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }

//     const submitData = {
//       ...formData,
//       features: formData.features.filter(f => f.trim() !== ''),
//       addOns: formData.addOns.filter(a => a.title.trim() !== '').map(a => ({
//         ...a,
//         price: parseFloat(a.price) || 0,
//       })),
//       dealerLimit: Number(formData.dealerLimit),
//       extraDealerPrice: Number(formData.extraDealerPrice),
//       setupFee: Number(formData.setupFee) || 0,
//       trialDays: formData.hasTrial ? Number(formData.trialDays) : 0,
//       customPlan: formData.customPlan,
//       expiryDate: formData.expiryDate ? formData.expiryDate.toDate() : null,
//     };

//     if (plan) {
//       await dispatch(updatePlan({ id: plan._id, planData: submitData }));
//     } else {
//       await dispatch(createPlan(submitData));
//     }
    
//     onClose();
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Plan Name"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               error={!!errors.name}
//               helperText={errors.name}
//               required
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Plan Title (Optional)"
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               error={!!errors.title}
//               helperText={errors.title}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <FormControl fullWidth error={!!errors.platforms}>
//               <InputLabel>Platforms *</InputLabel>
//               <Select
//                 multiple
//                 name="platforms"
//                 value={formData.platforms}
//                 onChange={handleChange}
//                 input={<OutlinedInput label="Platforms *" />}
//                 renderValue={(selected) => (
//                   <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                     {selected.map((value) => (
//                       <Chip key={value} label={value} size="small" />
//                     ))}
//                   </Box>
//                 )}
//               >
//                 {platforms.map((platform) => (
//                   <MenuItem key={platform} value={platform}>
//                     <Checkbox checked={formData.platforms.indexOf(platform) > -1} />
//                     <ListItemText primary={platform} />
//                   </MenuItem>
//                 ))}
//               </Select>
//               {errors.platforms && (
//                 <FormHelperText error>{errors.platforms}</FormHelperText>
//               )}
//             </FormControl>
//           </Grid>

//           <Grid item xs={12}>
//             <Typography variant="subtitle1" gutterBottom fontWeight="bold">
//               Billing Options
//             </Typography>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper variant="outlined" sx={{ p: 2 }}>
//               <Typography variant="subtitle2" gutterBottom color="primary">
//                 Monthly Billing
//               </Typography>
//               <TextField
//                 fullWidth
//                 label="Monthly Price"
//                 name="billingOptions.monthly.price"
//                 type="number"
//                 value={formData.billingOptions.monthly.price}
//                 onChange={handleChange}
//                 error={!!errors.monthlyPrice}
//                 helperText={errors.monthlyPrice}
//                 required
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//                 size="small"
//                 sx={{ mb: 1 }}
//               />
//               <TextField
//                 fullWidth
//                 label="Discount %"
//                 name="billingOptions.monthly.discount"
//                 type="number"
//                 value={formData.billingOptions.monthly.discount}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, max: 100, step: 1 } }}
//                 size="small"
//               />
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Paper variant="outlined" sx={{ p: 2 }}>
//               <Typography variant="subtitle2" gutterBottom color="secondary">
//                 Yearly Billing
//               </Typography>
//               <TextField
//                 fullWidth
//                 label="Yearly Price"
//                 name="billingOptions.yearly.price"
//                 type="number"
//                 value={formData.billingOptions.yearly.price}
//                 onChange={handleChange}
//                 error={!!errors.yearlyPrice}
//                 helperText={errors.yearlyPrice}
//                 required
//                 InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//                 size="small"
//                 sx={{ mb: 1 }}
//               />
//               <TextField
//                 fullWidth
//                 label="Discount %"
//                 name="billingOptions.yearly.discount"
//                 type="number"
//                 value={formData.billingOptions.yearly.discount}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 0, max: 100, step: 1 } }}
//                 size="small"
//               />
//             </Paper>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <TextField
//               fullWidth
//               label="Plan Validity (days)"
//               name="planValidity"
//               type="number"
//               value={formData.planValidity}
//               onChange={handleChange}
//               InputProps={{ inputProps: { min: 1 } }}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <DatePicker
//               label="Expiry Date (Optional)"
//               value={formData.expiryDate}
//               onChange={(newValue) => setFormData(prev => ({ ...prev, expiryDate: newValue }))}
//               slotProps={{ textField: { fullWidth: true } }}
//               minDate={dayjs()}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={formData.hasTrial}
//                   onChange={handleChange}
//                   name="hasTrial"
//                   color="info"
//                 />
//               }
//               label="Has Trial Period"
//             />
//           </Grid>

          
//           {formData.hasTrial && (
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Trial Days"
//                 name="trialDays"
//                 type="number"
//                 value={formData.trialDays}
//                 onChange={handleChange}
//                 InputProps={{ inputProps: { min: 1, max: 90 } }}
//               />
//             </Grid>
//           )}

//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Dealer Limit"
//               name="dealerLimit"
//               type="number"
//               value={formData.dealerLimit}
//               onChange={handleChange}
//               error={!!errors.dealerLimit}
//               helperText={errors.dealerLimit}
//               required
//               InputProps={{ inputProps: { min: 0 } }}
//             />
//           </Grid>

//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Extra Dealer Price"
//               name="extraDealerPrice"
//               type="number"
//               value={formData.extraDealerPrice}
//               onChange={handleChange}
//               error={!!errors.extraDealerPrice}
//               helperText={errors.extraDealerPrice}
//               required
//               InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//             />
//           </Grid>

//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Setup Fee"
//               name="setupFee"
//               type="number"
//               value={formData.setupFee}
//               onChange={handleChange}
//               InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={formData.isPopular}
//                   onChange={handleChange}
//                   name="isPopular"
//                   color="primary"
//                 />
//               }
//               label="Mark as Popular"
//             />
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={formData.isActive}
//                   onChange={handleChange}
//                   name="isActive"
//                   color="success"
//                 />
//               }
//               label="Active"
//             />

//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={formData.customPlan}
//                   onChange={handleChange}
//                   name="customPlan"
//                   color="info"
//                 />
//               }
//               label="Custom Plan"
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <Divider sx={{ my: 2 }} />
//             <Typography variant="subtitle1" gutterBottom fontWeight="bold">
//               Features
//             </Typography>
//             {formData.features.map((feature, index) => (
//               <Box key={index} display="flex" alignItems="center" mb={1}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label={`Feature ${index + 1}`}
//                   value={feature}
//                   onChange={(e) => handleFeatureChange(index, e.target.value)}
//                   placeholder="Enter feature description"
//                 />
//                 <IconButton 
//                   onClick={() => removeFeature(index)}
//                   color="error"
//                   disabled={formData.features.length === 1}
//                 >
//                   <DeleteIcon />
//                 </IconButton>
//               </Box>
//             ))}
//             <Button
//               startIcon={<AddIcon />}
//               onClick={addFeature}
//               size="small"
//               sx={{ mt: 1 }}
//             >
//               Add Feature
//             </Button>
//           </Grid>

//           <Grid item xs={12}>
//             <Divider sx={{ my: 2 }} />
//             <Typography variant="subtitle1" gutterBottom fontWeight="bold">
//               Add-ons
//             </Typography>
//             {formData.addOns.map((addon, index) => (
//               <Paper key={index} sx={{ p: 2, mb: 2 }} variant="outlined">
//                 <Grid container spacing={1}>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Title"
//                       value={addon.title}
//                       onChange={(e) => handleAddOnChange(index, 'title', e.target.value)}
//                       placeholder="Add-on title"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Price"
//                       type="number"
//                       value={addon.price}
//                       onChange={(e) => handleAddOnChange(index, 'price', e.target.value)}
//                       placeholder="Price"
//                       InputProps={{ inputProps: { min: 0, step: 0.01 } }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Billing Type</InputLabel>
//                       <Select
//                         value={addon.billingType}
//                         label="Billing Type"
//                         onChange={(e) => handleAddOnChange(index, 'billingType', e.target.value)}
//                       >
//                         {billingTypes.map((type) => (
//                           <MenuItem key={type} value={type}>
//                             {type.charAt(0).toUpperCase() + type.slice(1)}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={2}>
//                     <Box display="flex" alignItems="center">
//                       <TextField
//                         fullWidth
//                         size="small"
//                         label="Description"
//                         value={addon.description}
//                         onChange={(e) => handleAddOnChange(index, 'description', e.target.value)}
//                         placeholder="Description"
//                       />
//                       <IconButton 
//                         onClick={() => removeAddOn(index)}
//                         color="error"
//                         disabled={formData.addOns.length === 1}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Paper>
//             ))}
//             <Button
//               startIcon={<AddIcon />}
//               onClick={addAddOn}
//               size="small"
//             >
//               Add Add-on
//             </Button>
//           </Grid>

//           <Grid item xs={12}>
//             <Box display="flex" justifyContent="flex-end" gap={2} sx={{ mt: 2 }}>
//               <Button onClick={onClose}>Cancel</Button>
//               <Button type="submit" variant="contained" color="primary">
//                 {plan ? 'Update' : 'Create'} Plan
//               </Button>
//             </Box>
//           </Grid>
//         </Grid>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default PlanForm;

import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Switch,
  Chip,
  IconButton,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Paper,
  Divider,
  FormHelperText,
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { createPlan, updatePlan } from '../../redux/slices/planSlice';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const platforms = ['WEB', 'ANDROID', 'IOS'];
const billingTypes = ['one-time', 'monthly', 'yearly'];

const PlanForm = ({ plan, onClose }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: plan?.name || '',
    platforms: plan?.platforms || [],
    title: plan?.title || '',
    subTitle: plan?.subTitle || '',
    billingOptions: {
      monthly: {
        price: plan?.billingOptions?.monthly?.price || '',
        discount: plan?.billingOptions?.monthly?.discount || 0,
      },
      yearly: {
        price: plan?.billingOptions?.yearly?.price || '',
        discount: plan?.billingOptions?.yearly?.discount || 0,
      },
    },
    planValidity: plan?.planValidity || 30,
    dealerPrice: plan?.dealerPrice || '',
    setupFee: plan?.setupFee || 0,
    features: plan?.features?.length ? plan.features : [''],
    addOns: plan?.addOns?.length ? plan.addOns : [{ title: '', price: '', description: '', billingType: 'monthly' }],
    isPopular: plan?.isPopular || false,
    isActive: plan?.isActive ?? true,
    expiryDate: plan?.expiryDate ? dayjs(plan.expiryDate) : null,
    hasTrial: plan?.hasTrial || false,
    customPlan: plan?.customPlan || false,
    trialDays: plan?.trialDays || 0,
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (formData.platforms.length === 0) newErrors.platforms = 'At least one platform is required';
    
    if (!formData.billingOptions.monthly.price || formData.billingOptions.monthly.price < 0) {
      newErrors.monthlyPrice = 'Valid monthly price is required';
    }
    if (!formData.billingOptions.yearly.price || formData.billingOptions.yearly.price < 0) {
      newErrors.yearlyPrice = 'Valid yearly price is required';
    }
    
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.includes('.')) {
      const [parent, child, grandChild] = name.split('.');
      if (grandChild) {
        setFormData(prev => ({
          ...prev,
          [parent]: {
            ...prev[parent],
            [child]: {
              ...prev[parent][child],
              [grandChild]: type === 'number' ? parseFloat(value) || 0 : value,
            }
          }
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [parent]: {
            ...prev[parent],
            [child]: type === 'number' ? parseFloat(value) || 0 : value,
          }
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : (type === 'number' ? parseFloat(value) || 0 : value),
      }));
    }
  };

  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...formData.features];
    updatedFeatures[index] = value;
    setFormData(prev => ({ ...prev, features: updatedFeatures }));
  };

  const addFeature = () => {
    setFormData(prev => ({
      ...prev,
      features: [...prev.features, ''],
    }));
  };

  const removeFeature = (index) => {
    if (formData.features.length > 1) {
      setFormData(prev => ({
        ...prev,
        features: prev.features.filter((_, i) => i !== index),
      }));
    }
  };

  const handleAddOnChange = (index, field, value) => {
    const updatedAddOns = [...formData.addOns];
    updatedAddOns[index] = { ...updatedAddOns[index], [field]: value };
    setFormData(prev => ({ ...prev, addOns: updatedAddOns }));
  };

  const addAddOn = () => {
    setFormData(prev => ({
      ...prev,
      addOns: [...prev.addOns, { title: '', price: '', description: '', billingType: 'monthly' }],
    }));
  };

  const removeAddOn = (index) => {
    if (formData.addOns.length > 1) {
      setFormData(prev => ({
        ...prev,
        addOns: prev.addOns.filter((_, i) => i !== index),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const submitData = {
      name: formData.name,
      platforms: formData.platforms,
      title: formData.title || undefined,
      subTitle: formData.subTitle || undefined,
      billingOptions: {
        monthly: {
          price: Number(formData.billingOptions.monthly.price),
          discount: Number(formData.billingOptions.monthly.discount) || 0,
        },
        yearly: {
          price: Number(formData.billingOptions.yearly.price),
          discount: Number(formData.billingOptions.yearly.discount) || 0,
        },
      },
      planValidity: Number(formData.planValidity) || 30,
      dealerPrice: formData.dealerPrice ? Number(formData.dealerPrice) : undefined,
      setupFee: Number(formData.setupFee) || 0,
      features: formData.features.filter(f => f && f.trim() !== ''),
      addOns: formData.addOns
        .filter(a => a.title && a.title.trim() !== '')
        .map(a => ({
          title: a.title,
          price: Number(a.price) || 0,
          description: a.description || undefined,
          billingType: a.billingType,
        })),
      isPopular: formData.isPopular,
      isActive: formData.isActive,
      expiryDate: formData.expiryDate ? formData.expiryDate.toDate() : null,
      hasTrial: formData.hasTrial,
      customPlan: formData.customPlan,
      trialDays: formData.hasTrial ? Number(formData.trialDays) : 0,
    };

    if (plan) {
      await dispatch(updatePlan({ id: plan._id, planData: submitData }));
    } else {
      await dispatch(createPlan(submitData));
    }
    
    onClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Plan Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Plan Title (Optional)"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Plan Subtitle (Optional)"
              name="subTitle"
              value={formData.subTitle}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth error={!!errors.platforms}>
              <InputLabel>Platforms *</InputLabel>
              <Select
                multiple
                name="platforms"
                value={formData.platforms}
                onChange={handleChange}
                input={<OutlinedInput label="Platforms *" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} size="small" />
                    ))}
                  </Box>
                )}
              >
                {platforms.map((platform) => (
                  <MenuItem key={platform} value={platform}>
                    <Checkbox checked={formData.platforms.indexOf(platform) > -1} />
                    <ListItemText primary={platform} />
                  </MenuItem>
                ))}
              </Select>
              {errors.platforms && (
                <FormHelperText error>{errors.platforms}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              Billing Options
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom color="primary">
                Monthly Billing
              </Typography>
              <TextField
                fullWidth
                label="Monthly Price"
                name="billingOptions.monthly.price"
                type="number"
                value={formData.billingOptions.monthly.price}
                onChange={handleChange}
                error={!!errors.monthlyPrice}
                helperText={errors.monthlyPrice}
                required
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                size="small"
                sx={{ mb: 1 }}
              />
              <TextField
                fullWidth
                label="Discount %"
                name="billingOptions.monthly.discount"
                type="number"
                value={formData.billingOptions.monthly.discount}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, max: 100, step: 1 } }}
                size="small"
              />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom color="secondary">
                Yearly Billing
              </Typography>
              <TextField
                fullWidth
                label="Yearly Price"
                name="billingOptions.yearly.price"
                type="number"
                value={formData.billingOptions.yearly.price}
                onChange={handleChange}
                error={!!errors.yearlyPrice}
                helperText={errors.yearlyPrice}
                required
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                size="small"
                sx={{ mb: 1 }}
              />
              <TextField
                fullWidth
                label="Discount %"
                name="billingOptions.yearly.discount"
                type="number"
                value={formData.billingOptions.yearly.discount}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 0, max: 100, step: 1 } }}
                size="small"
              />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Plan Validity (days)"
              name="planValidity"
              type="number"
              value={formData.planValidity}
              onChange={handleChange}
              InputProps={{ inputProps: { min: 1 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Dealer Price"
              name="dealerPrice"
              type="number"
              value={formData.dealerPrice}
              onChange={handleChange}
              InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              helperText="Price for dealers (optional)"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Setup Fee"
              name="setupFee"
              type="number"
              value={formData.setupFee}
              onChange={handleChange}
              InputProps={{ inputProps: { min: 0, step: 0.01 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Expiry Date (Optional)"
              value={formData.expiryDate}
              onChange={(newValue) => setFormData(prev => ({ ...prev, expiryDate: newValue }))}
              slotProps={{ textField: { fullWidth: true } }}
              minDate={dayjs()}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.hasTrial}
                  onChange={handleChange}
                  name="hasTrial"
                  color="info"
                />
              }
              label="Has Trial Period"
            />
          </Grid>

          {formData.hasTrial && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Trial Days"
                name="trialDays"
                type="number"
                value={formData.trialDays}
                onChange={handleChange}
                InputProps={{ inputProps: { min: 1, max: 90 } }}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.isPopular}
                  onChange={handleChange}
                  name="isPopular"
                  color="primary"
                />
              }
              label="Mark as Popular"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.isActive}
                  onChange={handleChange}
                  name="isActive"
                  color="success"
                />
              }
              label="Active"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.customPlan}
                  onChange={handleChange}
                  name="customPlan"
                  color="info"
                />
              }
              label="Custom Plan"
            />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              Features
            </Typography>
            {formData.features.map((feature, index) => (
              <Box key={index} display="flex" alignItems="center" mb={1}>
                <TextField
                  fullWidth
                  size="small"
                  label={`Feature ${index + 1}`}
                  value={feature}
                  onChange={(e) => handleFeatureChange(index, e.target.value)}
                  placeholder="Enter feature description"
                />
                <IconButton 
                  onClick={() => removeFeature(index)}
                  color="error"
                  disabled={formData.features.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
            <Button
              startIcon={<AddIcon />}
              onClick={addFeature}
              size="small"
              sx={{ mt: 1 }}
            >
              Add Feature
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
              Add-ons
            </Typography>
            {formData.addOns.map((addon, index) => (
              <Paper key={index} sx={{ p: 2, mb: 2 }} variant="outlined">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Title"
                      value={addon.title}
                      onChange={(e) => handleAddOnChange(index, 'title', e.target.value)}
                      placeholder="Add-on title"
                      // required
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Price"
                      type="number"
                      value={addon.price}
                      onChange={(e) => handleAddOnChange(index, 'price', e.target.value)}
                      placeholder="Price"
                      InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                      // required
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Billing Type</InputLabel>
                      <Select
                        value={addon.billingType}
                        label="Billing Type"
                        onChange={(e) => handleAddOnChange(index, 'billingType', e.target.value)}
                      >
                        {billingTypes.map((type) => (
                          <MenuItem key={type} value={type}>
                            {type.charAt(0).toUpperCase() + type.slice(1)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Description"
                      value={addon.description}
                      onChange={(e) => handleAddOnChange(index, 'description', e.target.value)}
                      placeholder="Description"
                      multiline
                      rows={1}
                    />
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <IconButton 
                      onClick={() => removeAddOn(index)}
                      color="error"
                      disabled={formData.addOns.length === 1}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Paper>
            ))}
            <Button
              startIcon={<AddIcon />}
              onClick={addAddOn}
              size="small"
              sx={{ mt: 1 }}
            >
              Add Add-on
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" gap={2} sx={{ mt: 3 }}>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="contained" color="primary">
                {plan ? 'Update' : 'Create'} Plan
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </LocalizationProvider>
  );
};

export default PlanForm;